// extracted by mini-css-extract-plugin
export var buttonContainer = "_68-1";
export var fontSizeSelect = "_68-3";
export var formatSelect = "_68-2";
export var formats = "_68-4";
export var hidden = "_68-5";
export var icon = "_68-6";
export var select = "_68-0";